import React from "react";
import { Phone, Mail, MessageCircle, MapPin, Facebook, Instagram } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import Logo from "./Logo";

export default function Footer() {
    const { t } = useLang();
    return (
        <footer id="contact" className="bg-[#0B1B33] text-slate-300 mt-32" data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-3 gap-12">
                <div>
                    <div className="mb-5">
                        <Logo variant="dark" size="sm" />
                    </div>
                    <p className="text-sm leading-relaxed text-slate-400 max-w-xs mb-5">{t("footer.tagline")}</p>
                    <div className="flex items-center gap-3" data-testid="social-icons">
                        <a
                            href="https://www.facebook.com/privathilfe.ch"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Privathilfe.ch auf Facebook"
                            data-testid="social-facebook"
                            className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#16A34A] border border-white/10 flex items-center justify-center text-white transition-colors"
                        >
                            <Facebook className="w-4 h-4" />
                        </a>
                        <a
                            href="https://www.instagram.com/privathilfe.ch"
                            target="_blank"
                            rel="noreferrer"
                            aria-label="Privathilfe.ch auf Instagram"
                            data-testid="social-instagram"
                            className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#16A34A] border border-white/10 flex items-center justify-center text-white transition-colors"
                        >
                            <Instagram className="w-4 h-4" />
                        </a>
                    </div>
                </div>

                <div>
                    <h4 className="text-white font-display font-bold mb-5 text-base">{t("footer.contact")}</h4>
                    <ul className="space-y-3 text-sm">
                        <li className="flex items-start gap-3">
                            <MapPin className="w-4 h-4 text-[#4ADE80] mt-0.5 flex-shrink-0" />
                            <span>
                                <a
                                    href="https://www.google.com/maps/search/?api=1&query=Feld%C3%A4ckerweg+3%2C+9545+W%C3%A4ngi"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="hover:text-white transition-colors"
                                    data-testid="footer-address-link"
                                >
                                    Feldäckerweg 3<br />9545 Wängi
                                </a>
                                <br /><span className="text-slate-500 text-xs">Region Ostschweiz / Zürcher Oberland</span>
                            </span>
                        </li>
                        <li className="flex items-center gap-3">
                            <Phone className="w-4 h-4 text-[#4ADE80]" />
                            <a href="tel:0786030294" className="hover:text-white transition-colors" data-testid="footer-phone-link">078 603 02 94</a>
                        </li>
                        <li className="flex items-center gap-3">
                            <MessageCircle className="w-4 h-4 text-[#4ADE80]" />
                            <a href="https://wa.me/41786030294" target="_blank" rel="noreferrer" className="hover:text-white transition-colors" data-testid="footer-whatsapp-link">WhatsApp 078 603 02 94</a>
                        </li>
                        <li className="flex items-center gap-3">
                            <Mail className="w-4 h-4 text-[#4ADE80]" />
                            <a href="mailto:info@privathilfe.ch" className="hover:text-white transition-colors" data-testid="footer-email-link">info@privathilfe.ch</a>
                        </li>
                    </ul>

                    {/* Google Maps embed removed — now in ServiceArea section */}
                </div>

                <div>
                    <h4 className="text-white font-display font-bold mb-5 text-base">{t("footer.services_h")}</h4>
                    <ul className="space-y-2.5 text-sm text-slate-400">
                        <li>{t("services.privat.title")}</li>
                        <li>{t("services.scheiben.title")}</li>
                        <li>{t("services.begleit.title")}</li>
                        <li>{t("services.buero.title")}</li>
                        <li>{t("services.gebaeude.title")}</li>
                    </ul>
                </div>
            </div>
            <div className="border-t border-white/10">
                <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 text-xs text-slate-500 flex flex-col md:flex-row justify-between gap-2">
                    <span>© {new Date().getFullYear()} Privathilfe.ch — {t("footer.rights")}</span>
                    <span>Sauberkeit, auf die Sie sich verlassen können.</span>
                </div>
            </div>
        </footer>
    );
}
